import {AnyAction} from 'redux';
import {SET_REGISTRY} from '../actionTypes';
import {RegistryState} from '../reducers/registry';

export const setRegistrySuccess = (payload = {}) => ({
  type: SET_REGISTRY,
  payload,
});

export const setRegistry = (value: RegistryState) => {
  return (dispatch: (action: AnyAction) => void) => {
    dispatch(setRegistrySuccess(value));
  };
};
